import dualPlayer from './module/dual-player';

const CONTEXTUAL_DELIVERY_CAP = 0; // no delivery
const PLAYLIST_DELIVERY_CAP = 0; // no delivery

const tags: string[] = [];
const videoChannelIds: string[] = [];
const playerConfig = {
  video_loaded_source: 'STD',
  brand_safety: '',
  video_audio: 'true',
  audio_volume: 0,
  video_content_init: 'STP',
  video_domain: 'www.kooora.com',
  video_partner: '13681',
  video_player_type: 'SIXTEENBYNINE',
  video_player_width: '',
  video_type: '',
  video_embed_type: 'SEMANTIC',
  media_items: [
    {
      media_id: '',
      tags,
      right_holder_id: '',
      video_channel_ids: videoChannelIds,
    },
  ],
};

const playerConfigForAdSpot = {
  adBreakType: 'preroll',
  adPod: 1,
  playerWidth: 640,
  playerHeight: 480,
};

const pixelsGetLongitudeAdTag = async () => {
  const longitudeScript = document.createElement('script');
  longitudeScript.defer = true;
  longitudeScript.src = 'https://lngtd.com/fcplayer_pixels.js';
  document.head.appendChild(longitudeScript);
  return await pixelsWaitFor('fcpixels_lngtd', 15000)
    .then(() => pixelsGetTag())
    .catch(error => console.error(error));
};

const pixelsGetTag = async () => {
  return await window.fcpixels_lngtd.getAdvertisingUrlPromiseForFCPlayer(playerConfig, playerConfigForAdSpot);
};

const pixelsWaitFor = (obj: string, timeoutDuration: number) => {
  return new Promise<void>((resolve, reject) => {
    const interval = 100; // Check every 100ms
    let elapsed = 0;

    const checkObject = setInterval(() => {
      if (window[obj]) {
        clearInterval(checkObject);
        resolve();
      } else {
        elapsed += interval;
        if (elapsed >= timeoutDuration) {
          clearInterval(checkObject);
          reject(new Error(`Timeout: window.${obj} not found in window after ${timeoutDuration}ms`));
        }
      }
    }, interval);
  });
};

window.pixelsDualInject = dualPlayer({
  adTagUrlPromise: pixelsGetLongitudeAdTag(),
  contextualDeliveryCap: CONTEXTUAL_DELIVERY_CAP,
  playlistDeliveryCap: PLAYLIST_DELIVERY_CAP,
  organisation: 'kooora',
  playlist: __ENV_MODE__ === 'prod' ? 'f3a40fe5-84f0-4a78-820d-f3536f0d88f6' : '60eca178-5e9c-4d81-9764-42b7f7982ee2',
  midArticlePlaylist: __ENV_MODE__ === 'prod' ? ['f3a40fe5-84f0-4a78-820d-f3536f0d88f6', '1f866921-f4f3-4af6-bf50-11de0608379b'] : ['0a59a62d-230e-4022-8423-f26743373381', '0a59a62d-230e-4022-8423-f26743373381'],
});
